import React, { SyntheticEvent, useContext } from 'react'
import { DropdownProps, Form, Select } from 'semantic-ui-react'
import { SiteProps } from '../../../interfaces'
import NumberInput from '../../ui/NumberInput'
import formatLengthUnit from '~/utils/formatLengthUnit'
import { rigLabel } from '~/utils/rigLabel'
import { titleCase } from '~/utils'

interface ComponentProps {
  userRigLength: number
  handleRigLengthChange: (event: SyntheticEvent, data: DropdownProps) => void
  isBoat: boolean
  isCamperLength: boolean
  sites: SiteProps[]
  error: string
  setError: (v: string) => void
  lengthUnit: string
}

const MaxRigLengthField = ({ userRigLength, handleRigLengthChange, isBoat, isCamperLength, sites, error, setError, lengthUnit }: ComponentProps) => {

  const label =  titleCase(rigLabel(isBoat, isCamperLength, lengthUnit)) + " Length"

  return (
    <div className="">
      <div className="flex justify-between items-center">
        <Form.Field className="flex flex-col justify-center">
          <div className="font-bold text-lg mb-1">
            {label} ({formatLengthUnit(lengthUnit)})
          </div>
        </Form.Field>
        <div className="relative">
          <input
            aria-label="max rig length"
            type="number"
            value={userRigLength}
            onChange={(e) => {
              setError("")
              handleRigLengthChange(e, { value: e.target.value })
            }}
            className="border border-gray-300 text-center text-lg col-span-2 numberInputWithoutArrows rounded-md"
            style={{
              padding: "5px 20px 5px 5px",
              width: 100,
              fontSize: 18,
              height: 34,
            }}
          />
          <div className="absolute right-2 top-1.5 text-lg">{formatLengthUnit(lengthUnit)}</div>
        </div>
      </div>

      {error?.length ? <div className="text-red-600 font-semibold">{error}</div> : <></>}
    </div>
  )
}

export default MaxRigLengthField
